import create from "zustand";
import {AudioListener} from "three";
import PlayerBehaviour from "./lib/PlayerBehaviour";
import {IInteractableMesh} from "./components/three/InteractiveMesh";

export const audioListener = new AudioListener();

const [useStore] = create((set) => ({
  showOnboarding: true,
  toggleShowOnboarding: () =>
    set((state) => ({showOnboarding: !state.showOnboarding})),
  audioListener: new AudioListener(),
  playerBehaviour: new PlayerBehaviour(),
  interactiveObjs: [],
  addInteractiveObj: (obj: any) =>
    set((state) => ({
      interactiveObjs: [obj, ...state.interactiveObjs],
    })),
  removeInteractiveObj: (obj: any) =>
    set((state) => ({
      interactiveObjs: state.interactiveObjs.filter((o: any) => o !== obj),
    })),
  activeInteractiveObj: null,
  setActiveInteractiveObj: (obj: IInteractableMesh | null) =>
    set(() => ({activeInteractiveObj: obj})),
  isSceneLoaded: false,
  sceneHasLoaded: () => set(() => ({isSceneLoaded: true})),
}));

export default useStore;
